import { Collapsible as BaseCollapsible } from '@base-ui/react/collapsible'
import { twMerge } from 'tailwind-merge'
import { CollapsibleTrigger } from './nested/trigger'
import { CollapsibleContent } from './nested/content'
import type { PartProps } from '../../lib/part-props'

interface CollapsibleRootProps extends PartProps<BaseCollapsible.Root.Props> {
  className?: string
}

function Collapsible({ className, children, ...props }: CollapsibleRootProps) {
  return (
    <BaseCollapsible.Root className={twMerge('flex flex-col justify-center', className)} {...props}>
      {children}
    </BaseCollapsible.Root>
  )
}

Collapsible.Trigger = CollapsibleTrigger
Collapsible.Content = CollapsibleContent

export { Collapsible }
